// extracted by mini-css-extract-plugin
export default {"textBlockWrapper":"_1mDxW","open":"_2OmMc"};